class OlabUtils {
  // Limit to 200 items per package
  static MAX_ITEMS_PER_PACKAGE = 200;
  // Limit to 20 items per cart
  static MAX_ITEMS_PER_CART = 20;

  constructor(type) {
    this.stats = {
      count: 0
    };
    this.type = type;
    this.nop = null;
  }

  addCount(cnt) {
    this.stats.count += cnt;
  }

  static infoLog(str) {
    // this.nop = str;
    /* eslint-disable no-console */
    console.info("Info: " + str);
    /* eslint-enable no-console */
  }

  static warnLog(str) {
    this.nop = str;
    // /* eslint-disable no-console */
    // console.warn("Warn: " + str);
    // /* eslint-enable no-console */
  }

  static errorLog(str) {
    this.nop = str;
    // /* eslint-disable no-console */
    // console.error("Error: " + str);
    // /* eslint-enable no-console */
  }
}

export { OlabUtils };
